var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-width"},[_c('h6',{staticClass:"subheading mb-1",class:{ 'text-ellipsis': !_vm.isFullView, 'black--text': _vm.isRepost }},[_vm._v(_vm._s(_vm.getCaption(_vm.post)))]),_c('h6',{staticClass:"mb-0 pa-1 hashtag",class:{ 'is-adult-tag': _vm.isAdultTag(_vm.post) }},[_vm._v(_vm._s(_vm.getHashtag(_vm.post)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }